export default function imageIdToURI(imageId) {
    if (!imageId) {
        return '';
    }
    const colonIndex = imageId.indexOf(':');
    return colonIndex === -1 ? imageId : imageId.substring(colonIndex + 1);
}
